import * as backend from 'backend-helpers/profiles';

const REQUEST_PROFILES = "REQUEST_PROFILES";
const RECEIVE_PROFILES = "RECEIVE_PROFILES";
const REQUEST_PROFILES_FAILURE = "REQUEST_PROFILES_FAILURE";

const initState = {
    isFetching: false,
    list: null,
    totalCount: 0
};

export default function main(state = initState, action) {
    switch (action.type) {
        case REQUEST_PROFILES: {
            return {
                ...state,
                isFetching: true
            };
        }

        case RECEIVE_PROFILES: {
            return {
                ...action.result.data, // list, totalCount
                isFetching: false
            }

        }
    }

    return state;
}

export function getProfiles(data) {
    return {
        promise: backend.getProfiles(data),
        types: [REQUEST_PROFILES, RECEIVE_PROFILES, REQUEST_PROFILES_FAILURE],
        data
    }
}


// WEBPACK FOOTER //
// ./src/reducers/profiles.js